import { useState } from 'react';
import { Popover, List, ListItemButton, ListItemText } from '@mui/material';
import Button from '@/components/CustomButtons/Button';
import { REFUND_TYPES } from '../../../utility';

export default function CopyFrom({ current, available, onSelected }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'open-from' : undefined;

  const options = available
    .filter((option) => option !== current)
    .map((option) => {
      if (option === REFUND_TYPES.REGULAR) {
        return {
          option,
          label: 'Consumer Payments',
        };
      }
      if (option === REFUND_TYPES.INSURANCE) {
        return {
          option,
          label: 'Insurance',
        };
      }
      if (option === REFUND_TYPES.BUSINESS) {
        return {
          option,
          label: 'Business Payments',
        };
      }
      return option;
    });

  const handleSelected = (option) => {
    onSelected(option);
    handleClose();
  };

  if (!options.length) {
    return null;
  }

  return (
    <>
      <Button
        aria-describedby={id}
        variant='contained'
        color='primary'
        onClick={handleClick}>
        Copy From
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}>
        <List component='nav'>
          {options.map((option) => (
            <ListItemButton
              key={option.label}
              onClick={() => handleSelected(option.option)}>
              <ListItemText primary={option.label} />
            </ListItemButton>
          ))}
        </List>
      </Popover>
    </>
  );
}
